exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-note{background-color:#feffc7}.sidebar-fixed{flex:\"0 0 260px\";width:\"260px\"}", ""]);

// exports
